import { SagaIterator } from 'redux-saga';
import {  select } from 'redux-saga/effects';

import { SessionSiteSelectors } from '../../bootstrap/redux/selectors/SessionInfoSelectors';
import { ContentActionsService } from '../../commonInfra/contentActions/ContentActions';
import { NewPredictiveModelForDatasourceAction } from '../actions/NewPredictiveModelForDatasourceAction';

export function* handleNewPredictiveModelForDatasourceAction(action: NewPredictiveModelForDatasourceAction): SagaIterator {
  const siteUrlName: string = yield select(SessionSiteSelectors.siteUrlName);
  ContentActionsService.newPredictiveModel(siteUrlName);
}

